// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#a)">
      <rect width={24} height={24} fill="#F3FFFA" rx={12} />
      <rect
        width={22.5}
        height={22.5}
        x={0.75}
        y={0.75}
        stroke="#16995C"
        strokeWidth={1.5}
        rx={11.25}
      />
      <path
        fill="#16995C"
        fillRule="evenodd"
        d="M17.098 7.39162L9.93797 14.3016L8.03797 12.2716C7.68797 11.9416 7.13797 11.9216 6.73797 12.2016C6.34797 12.4916 6.23797 13.0016 6.47797 13.4116L8.72797 17.0716C8.94797 17.4116 9.32797 17.6216 9.75797 17.6216C10.168 17.6216 10.558 17.4116 10.778 17.0716C11.138 16.6016 18.008 8.41162 18.008 8.41162C18.908 7.49162 17.818 6.68162 17.098 7.38162V7.39162Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <rect width={24} height={24} fill="#fff" rx={12} />
      </clipPath>
    </defs>
  </svg>
);
const IconCheckTick = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconCheckTick;
